import React, { ReactNode } from 'react';
import { EpiBlock } from '@api/types';
import { BlockEditorContextMenu } from '@components';
import { useEditMode } from '@hooks';
import { Box, styled } from '@mui/material';

const NativeModeWrapper = styled(Box)`
  &.epi-injected-minSize-inline {
    display: block !important;
  }
`;

export type BlockEditorMenuProps = {
  children?: ReactNode;
  id?: number;
  title?: string;
  enableContextMenu?: boolean;
  enableNativeOverlay?: boolean;
  block?: EpiBlock;
};

/**
 * Wraps block in box with 'Edit' button or native overlay
 */
export const BlockEditorMenu = ({
  children,
  id,
  title,
  block,
  enableContextMenu,
  enableNativeOverlay,
}: BlockEditorMenuProps) => {
  const { inEditMode } = useEditMode();
  if (enableNativeOverlay && inEditMode) {
    return (
      <NativeEditMode id={id} title={title}>
        {children}
      </NativeEditMode>
    );
  } else if (enableContextMenu && inEditMode) {
    return (
      <BlockEditorContextMenu id={id} title={title} block={block}>
        {children}
      </BlockEditorContextMenu>
    );
  }
  return <>{children}</>;
};

/**
 * Wraps block in box using native EPI attributes
 */
export const NativeEditMode = ({ id, title, children }: BlockEditorMenuProps) => {
  return (
    <NativeModeWrapper
      component='span'
      // TODO: Can we get content group data?
      data-contentgroup=''
      // TODO: what's this property?
      data-epi-block-info='{"missingrenderer":false}'
      data-epi-block-id={id}
      data-epi-content-name={title}
    >
      {children}
    </NativeModeWrapper>
  );
};
